import { render, staticRenderFns } from "./PaginationWithInput.vue?vue&type=template&id=78b85378&"
import script from "./PaginationWithInput.vue?vue&type=script&lang=ts&"
export * from "./PaginationWithInput.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationWithInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPagination,QIcon,QBtn});
